/** 浏览器标签级协作会话 ID（与 useCollabSession / 全量保存结构锁校验共用） */
export const COLLAB_CLIENT_SESSION_HEADER = 'X-Collab-Client-Session';

const STORAGE_KEY = 'aipd.collab.clientSessionId';

export function ensureCollabClientSessionId(): string {
  if (typeof sessionStorage === 'undefined') {
    return globalThis.crypto?.randomUUID?.() ?? `${Date.now()}-${Math.random().toString(36).slice(2)}`;
  }
  let id = sessionStorage.getItem(STORAGE_KEY);
  if (!id) {
    id = globalThis.crypto?.randomUUID?.() ?? `${Date.now()}-${Math.random().toString(36).slice(2)}`;
    sessionStorage.setItem(STORAGE_KEY, id);
  }
  return id;
}

export function attachCollabClientSessionHeader(
  headers: Record<string, string>,
): Record<string, string> {
  try {
    headers[COLLAB_CLIENT_SESSION_HEADER] = ensureCollabClientSessionId();
  } catch {
    /* ignore */
  }
  return headers;
}
